export default __webpack_public_path__ + "static/media/Figurado.d7fc414a.png";